import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Config from '../Config';
import moment from 'moment';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Loading from '../Loading';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

function Projectview() {
    const { isAuthorized, handleUnauthorized } = useAuthHandling();

    let navigate = useNavigate();
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/dashboard");
    }
    let { id } = useParams();
   const [cust, setCust] = useState([]);
  const [prof, setProf] = useState([]);
  const [sdate, setSdate] = useState("");
  const [edate, setEdate] = useState("");
  const [images, setImage] = useState([]);
  const [project, setProject] = useState([]);

  const [enqtoggle, setEnqtoggle] = useState([]);

  const [toggle, setToggle] = useState(false);
  const [enqres, setEnqres] = useState(false);



  const [loading, setLoading] = useState(false);

      const getcust = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/customer/get-customers-dropdown`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
    
        if (res.status === 200) {
          const data1 = await res.json();
          const data = data1.data;
          setCust(data);
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getcust();
        }
        
      };
    
      const getprof = async (e) => {
        const res = await fetch(
            `${Config.apiurl}/api/v1/data/professionals-dropdown`,
            {
                method: "GET",
            }
        );

        const data1 = await res.json();
        const data = data1.data;
        if (res.status === 404 || !data) {
            console.log("error");
        } else {
            setProf(data);
        }
    };
      const getinfo = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/project/project-view/${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
        if (res.status === 200 ) {
          const data = await res.json();
    
          setProject(data.data[0]);
          setImage(data.data[0].projectImageList);
          setSdate(moment(data.data[0].startDate).utc().format("YYYY-MM-DD"));
          setEdate(moment(data.data[0].endDate).utc().format("YYYY-MM-DD"));
          setLoading(true);
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
    
        }
      };

      useEffect(() => {
        getinfo();
        getcust();
        getprof();
      }, []);

  

    
  return (
    <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/projectlist">Project list</Link>
                            <Link to={"/editproject/" + id}>Edit</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Project View page</h4>
                                            {loading?
                                        <div className='row view_div_row'>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Project Name </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p> {project.projectName}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Slug </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {project.projectSlug}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Project Status </h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                        <p>  {project.projectStatus}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Location </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {project.location}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Start Date </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {sdate}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> End Date </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {edate}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Customer </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        {cust.map((cust,i)=>{
                                                            return(
                                                                <>
                                                                {cust._id===project.customer?
                                                                <p> {cust.name}</p>
                                                                :""
                                                                }
                                                                </>
                                                            )
                                                        })}
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Professional </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    <p> {project?.projectProfessionalInfo[0]?.name}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Professional mobile </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    <p> {project?.projectProfessionalInfo[0]?.mobile}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Professional Email </h6>
                                                    </div>
                                                    <div className='view_portion_p_1'>
                                                    <p> {project?.projectProfessionalInfo[0]?.email}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Professional location </h6>
                                                    </div>
                                                    <div className='view_portion_p_1'>
                                                    <p> {project?.projectProfessionalInfo[0]?.location}</p>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Professional Suspended </h6>
                                                    </div>
                                                    <div className='view_portion_p_1'>
                                                    <p> {project?.projectProfessionalInfo[0]?.suspended===true?"Yes":"No"}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Project Images </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        {images.map((img,i)=>{
                                                            return(
                                                                <img src={img.projectImage} style={{ width: "100px", height: "100px", marginTop: "10px",marginRight:"5px" }} />

                                                            )
                                                        })}

                                                    </div>

                                                </div>
                                            </div>



                                            {/* Enquiries */}

                                <div className='col-12 '>
                                    <div className='view_portion'>
                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setToggle(!toggle)}>
                                            <h6> Enquiries </h6>
                                            {toggle ?
                                                <span><IoIosArrowUp /></span>
                                                :
                                                <span><IoIosArrowDown /></span>
                                            }
                                        </div>
                                        {toggle ?
                                         
                                                        <div className='view_portion_p view_response_enq'>
                                                            <div className='row'>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry ID
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{project?.enquiryInfo[0]?.enquiryId}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry type
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{project?.enquiryInfo[0]?.enquiryType}</p>

                                                                </div>
                                                                {project?.enquiryInfo[0]?.enquiryType === 'Direct-enquiry' ?
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Enquiry Professional
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            {prof.map((prof) => {
                                                                                return (
                                                                                    <>
                                                                                        {prof._id === project?.enquiryInfo[0]?.professional ?
                                                                                            <p> {prof.name}</p>
                                                                                            : ""
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })
                                                                            }


                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Enquiry Category
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{project?.enquiryInfo[0]?.enquiryCategoryName}</p>

                                                                        </div>
                                                                    </>
                                                                }


                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(project?.enquiryInfo[0]?.enquiryDate).utc().format("YYYY-MM-DD")}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Expiry Date
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{moment(project?.enquiryInfo[0]?.enquiryExpiry).utc().format("YYYY-MM-DD")}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Location
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{project?.enquiryInfo[0]?.location}</p>

                                                                </div>

                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry Requirement
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{project?.enquiryInfo[0]?.requirement}</p>

                                                                </div>
                                                                <div className='col-6 col-md-3'>
                                                                    Enquiry status
                                                                </div>
                                                                <div className='col-6 col-md-9'>
                                                                    <p>{project?.enquiryInfo[0]?.status}</p>

                                                                </div>
                                                                {project?.enquiryInfo[0]?.customerdataType === 'Direct-enquiry' && project?.enquiryInfo[0]?.professionalResponse?.length > 0 && project?.enquiryInfo[0]?.professionalResponse[0]?.response === false ?
                                                                    <>
                                                                        <div className='col-6 col-md-3'>
                                                                            Professional Reject
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>Yes</p>

                                                                        </div>
                                                                        <div className='col-6 col-md-3'>
                                                                            Rejected Reason
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{project?.enquiryInfo[0]?.responseText}</p>

                                                                        </div>
                                                                    </>
                                                                    : ""}
                                                                {project?.enquiryInfo[0]?.response === true ?
                                                                    <>

                                                                        <div className='col-6 col-md-3'>
                                                                            Response
                                                                        </div>
                                                                        <div className='col-6 col-md-9'>
                                                                            <p>{project?.enquiryInfo[0]?.responseText}</p>

                                                                        </div>
                                                                    </>
                                                                    : ""}                                                               

                                                                <div className='col-12 '>
                                                                    <div className='view_portion'>
                                                                        <div className='view_portion_h6 view_portion_h6_togg' onClick={(e) => setEnqres(!enqres)}>
                                                                            <h6> Professional Responses </h6>
                                                                            {enqres === true ?
                                                                                <span><IoIosArrowUp /></span>
                                                                                :
                                                                                <span><IoIosArrowDown /></span>
                                                                            }
                                                                        </div>

                                                                        {enqres === true ?
                                                                            project?.enquiryInfo[0]?.professionalResponse.length > 0 ?
                                                                            project?.enquiryInfo[0]?.professionalResponse.map((resp, i) => {
                                                                                    return (
                                                                                        <div className='view_portion_p view_response_enq'>
                                                                                            <div className='row'>

                                                                                                <div className='col-6 col-md-3'>
                                                                                                    Professional
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {prof.map((prof, ind) => {
                                                                                                        return (
                                                                                                            <>
                                                                                                                {prof._id === resp.professional ?
                                                                                                                    <p> {prof.name}</p>
                                                                                                                    : ""
                                                                                                                }
                                                                                                            </>
                                                                                                        )
                                                                                                    })}

                                                                                                </div>
                                                                                                {project?.enquiryInfo[0]?.enquiryType === 'Direct-enquiry' && project?.enquiryInfo[0]?.professionalResponse?.length > 0 && project?.enquiryInfo[0]?.professionalResponse[0]?.response === false ?
                                                                                                    <>
                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Professional Reject
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>Yes</p>

                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Rejected Reason
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>{resp.responseText}</p>

                                                                                                        </div>
                                                                                                    </>
                                                                                                    : ""}
                                                                                                {resp.response === true ?
                                                                                                    <>

                                                                                                        <div className='col-6 col-md-3'>
                                                                                                            Response
                                                                                                        </div>
                                                                                                        <div className='col-6 col-md-9'>
                                                                                                            <p>{resp.responseText}</p>

                                                                                                        </div>
                                                                                                    </>
                                                                                                    : ""}



                                                                                                <div className='col-6 col-md-3'>
                                                                                                    User Accepted
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {resp.userAccepted === true ?
                                                                                                        <p>Yes</p>
                                                                                                        : <p>No</p>
                                                                                                    }

                                                                                                </div>
                                                                                                <div className='col-6 col-md-3'>
                                                                                                    User Rejected
                                                                                                </div>
                                                                                                <div className='col-6 col-md-9'>
                                                                                                    {resp.userReject === true ?
                                                                                                        <p>Yes</p>
                                                                                                        : <p>No</p>
                                                                                                    }
                                                                                                </div>



                                                                                            </div>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                                :
                                                                                <div className='view_portion_p'>
                                                                                    No Response found
                                                                                </div>
                                                                            : ""}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                  :""}



                                    </div>
                                </div>
                                {/* Enquiries end */}

                                        </div>
                                        :
                                        <Loading/>
                                                    }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Projectview
